import React, { type ReactElement } from 'react';

import {
  type CartItem,
  selectCartItems,
  selectDecreaseCart,
  selectIncreaseCart,
  selectRemoveProductCart,
  useCartStore,
} from '@/store/use-cart.store';

import Button from '@/common/components/button/button.component';
import Tag from '@/common/components/tag/tag.component';
import Text from '@/common/components/text';
import Toast from '@/common/components/toast/toast.component';
import { useBasket } from '@/common/hooks/use-basket.hook';

import Delete from '~/public/assets/images/svg/cart-delete.svg';
import Minus from '~/public/assets/images/svg/cart-minus.svg';
import Plus from '~/public/assets/images/svg/cart-plus.svg';

export default function CartOpertaion({
  item,
  productId,
  productVariantId,
  quantity,
  disable,
}: {
  item: CartItem;
  productId: number;
  productVariantId: number;
  quantity: number | string;
  disable?: boolean;
}): ReactElement {
  const increaseItem = useCartStore(selectIncreaseCart);
  const decreaseItem = useCartStore(selectDecreaseCart);
  const removeProduct = useCartStore(selectRemoveProductCart);
  const { removeBasketItem, removeBasket } = useBasket(item.vendor.id);
  const cartItems = useCartStore(selectCartItems);

  const handleDecrease = () => {
    const products =
      cartItems.find((cart) => cart.vendor.id === item.vendor.id)?.products ||
      [];
    const desiredProduct = products.find(
      (product) => product.productVariantId === productVariantId
    );
    if (desiredProduct && desiredProduct.quantity === 1) {
      if (products.length > 1) removeBasketItem(productVariantId);
      else removeBasket(item.vendor.id);
    }
    decreaseItem({
      vendor: item.vendor,
      product: { productId, productVariantId },
    });
  };

  const handleIncrease = () => {
    if (+quantity < 5) {
      increaseItem({
        vendor: item.vendor,
        product: { productId, productVariantId },
      });
    } else {
      Toast.error('حداکثر 5 عدد از این محصول قابل خرید است.');
    }
  };

  const removeHandler = () => {
    removeProduct(item.vendor.id, productVariantId);
    removeBasketItem(productVariantId);
  };

  return (
    <div className="mt-3 flex w-full justify-between lg:mt-0 lg:justify-end">
      <div className="flex items-center gap-x-3">
        {disable ? (
          <Tag type="ARCHIVED">محصول ناموجود</Tag>
        ) : (
          <>
            {' '}
            <Button
              className="h-8 w-8 items-center justify-center p-1"
              type="cart"
              onClick={handleIncrease}
            >
              <Plus className="mr-0.5 h-5 w-5" />
            </Button>
            <Text className="mt-0.5 w-10  text-center text-sm font-medium text-black-400">
              {quantity} عدد
            </Text>
            <Button
              className="flex h-8 w-8 items-center justify-center p-1"
              type="cart"
              onClick={() => {
                quantity === 1 ? removeHandler() : handleDecrease();
              }}
            >
              {quantity === 1 ? (
                <Delete className="h-5 w-5" />
              ) : (
                <Minus className="h-5 w-5" />
              )}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
